import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class WarehouseGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let warehouseAccess = localStorage.getItem('warehouse_access');
    if (warehouseAccess !== undefined && warehouseAccess !== null && warehouseAccess !== '' && warehouseAccess =='true') {
      return of(true);
    }
    else {
      this.router.navigate(['']);
      return of(false);
    }
  }
}